document.addEventListener("DOMContentLoaded", function() {
  // Loop over each section with the class "new-arrivals-section"
document.querySelectorAll('.new-arrivals-section:not(.custom-collection-slider)').forEach(function(section) {
    // Get the section ID
    var sectionId = section.id.split('-')[2];  // Extract section ID from 'new-arrivals-{section.id}'

    // Initialize Swiper for each section
    if (!sectionId) return;
    var sliderEl = document.getElementById('product-slider-' + sectionId);

    if (!sliderEl) return; // 🛑 STOP if not found

    var swiper = new Swiper(sliderEl, {
      // Modified Swiper configuration (same logic as ishi-category-block)
      slidesPerView: "auto",   // keep slide widths fixed (don’t shrink)
      spaceBetween: 20,
      loop: false,             // disable looping like Ishi block
      freeMode: true,          // allows natural scrolling
      grabCursor: true,        // show grab cursor
      watchOverflow: true,
    });

    // Handle the next and previous buttons
    var nextButton = document.getElementById('next-btn-' + sectionId);
    var prevButton = document.getElementById('prev-btn-' + sectionId);

    if (nextButton && prevButton) {
      nextButton.addEventListener('click', function() {
        swiper.slideNext();
      });

      prevButton.addEventListener('click', function() {
        swiper.slidePrev();
      });
    }

    // Recalculate swiper after images load (for lazyload)
    section.querySelectorAll("img").forEach(img => {
      if (!img.complete) 
        img.addEventListener("load", () => {
        if (swiper && typeof swiper.update === "function") {
          swiper.update();
        }
      });
    });
  });
});

// promo video js
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.promo-image-link').forEach(function(link) {
    var video = link.querySelector('video.primary-video');
    var isTouch = ('ontouchstart' in window) || navigator.maxTouchPoints > 0;
    var tapped = false;

    if (!video) return; // nothing to do when there's no video

    // Ensure attributes are set programmatically (defensive)
    try {
      video.muted = true;
      video.playsInline = true;
      video.loop = true;
      video.preload = 'metadata';
      // try to play (ignore promise rejection)
      var playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch(function(err){
          // Autoplay may be blocked — leave muted/poster visible; user can tap to play
        });
      }
    } catch (e) {}

    // Clicking the video is a user gesture: toggle mute / ensure play
    video.addEventListener('click', function (e) {
      // Toggle mute on click so user can hear audio on demand
      try {
        if (video.muted) {
            video.muted = false;
            video.play().catch(function(){});
        } else {
          // if they click while unmuted, pause toggle — optional behaviour
          // keeping it simple: keep playing but toggle mute off/on
          video.muted = true;
        }
      } catch (err) {}
      });

    // If user interacts (keyboard focus), show controls
      video.addEventListener('focus', function () {
        video.controls = true;
      });

    // Keep controls visible while interacting
    video.addEventListener('play', function () { video.controls = true; });
    video.addEventListener('volumechange', function () { video.controls = true; });

    // For touch devices: first tap interacts with video (prevent navigation), second tap follows link
    link.addEventListener('touchstart', function (e) {
      if (!video) return; // no video -> normal nav
      if (!tapped) {
        tapped = true;
        e.preventDefault(); // prevent navigation on first tap
        // try to play & unmute on user interaction (unmute only if user explicitly wants)
        try { video.play().catch(function(){}); } catch(e){}
        // reset tapped after short window (user must tap again to follow link)
        setTimeout(function(){ tapped = false; }, 700);
      } else {
        // second tap: allow navigation normally
      }
    });

    // Accessibility: if focus moves away hide controls (optional)
    link.addEventListener('focusout', function(e) {
      if (!link.contains(e.relatedTarget)) {
        // hide controls (but keep autoplay)
        try { video.controls = false; } catch(e) {}
      }
    });

    // Optional: ensure video remains playing when it becomes visible (e.g., come back from other tab)
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') {
        try { video.play().catch(function(){}); } catch(e) {}
      }
    });
  });
});
